import { mapState, mapMutations, createNamespacedHelpers } from "vuex";
import { countDown, conversion, addZero } from "@/tool";
import { format_date } from "@/filters/format_date";
import { format_case_name } from "@/filters/format_case_name";

import CustomButton from "@/partials/custom_button";
import { CustomBlockTitle } from "@/partials/custom_block_title";
import Button from "@/components/button";
import Picture from "@/components/picture";
import BlockPanel from "@/components/block_panel";
import Award from "@/components/award";
import LiveDropBox from "@/partials/live_drop_box";
import InteractivePanel from "@/components/interactive_panel";
import NoticeBoard from "@/components/noticeboard/index.vue";
import Number from "@/components/AnimateNumber/index.vue";
import NewMultiplePeopleCase from "../multiplePeopleCase/components/NewCase.vue";
import RollBox from "./components/rollBox.vue";
import * as apis from "@/api";
import countDownModel from "@/components/countDown";
import {
  GetItemDuration,
  GetItemName,
  GetItemSkinName,
  timeToCounter,
} from "@/tool";

import { roll_list } from "@/api";
import { CaseImg } from "@/components/UI";
import caseItem from "@/components/caseItem/index.vue";
import gameInstanceBox from "../gameInstanceBox/index.vue";
import roomConItem from "./components/roomConItem/index.vue";

const { mapActions: RollRoomsMapActions, mapGetters: RollRoomsMapGetters } =
  createNamespacedHelpers("roll_rooms");

export default {
  data() {
    return {
      roiiList: [],
      roiiListLoading: false,
      Alert: false,
      active_cate_index: 0,
      price_range_index: 0,
      price_range: [
        { min: 0, max: 99999999 },
        { min: 0, max: 1 },
        { min: 2, max: 19 },
        { min: 20, max: 49 },
        { min: 50, max: 99 },
        { min: 100, max: 999999 },
      ],
      /** 注销首页Roll房刷新 */
      roll_room_list: [],
      boxList: [],
      multiplePeople_cases_rules_show: false,
      new_multiplePeople_cases_show: false,
      deadline2: Date.now() + 1000 * 60 * 60 * 8,
      battleCaseList: [],
      caseData: [],
      multiplePeopleCaseRecentList: [],
      isRequest: false,
      mpcCaseSettings: {},
      active_cate: "all",
      price_range_value: "all",
      price_sort_index: "all",
      risk_sort_index: "all",
      price_range_list: [
        {
          label: "所有",
          value: "all",
          min: 0,
          max: 99999999,
        },
        {
          label: "0 — 1",
          value: "01",
          min: 0,
          max: 1,
        },
        {
          label: "2 — 19",
          value: "219",
          min: 2,
          max: 19,
        },
        {
          label: "20 — 49",
          value: "2049",
          min: 20,
          max: 49,
        },
        {
          label: "50 — 99",
          value: "5099",
          min: 50,
          max: 99,
        },
        {
          label: "100+",
          value: "100",
          min: 100,
          max: 999999,
        },
      ],
      price_sort_list: [
        {
          label: "价格降序",
          value: "descending",
        },
        {
          label: "价格升序",
          value: "ascending",
        },
      ],
      risk_sort_list: [
        {
          label: "L",
          value: "0",
        },
        {
          label: "M",
          value: "1",
        },
        {
          label: "H",
          value: "2",
        },
        {
          label: "l",
          value: "3",
        },
      ],
      mpcCaseSettings: {},
      mpcCaseTimer: null, // 用于存储计时器对象
      battleChallengeDetail: {
        isChallengeEnable: false,
      },
      isShowShaixuan: false,
      isFixed: false, // 是否固定在顶部
      stickyOffset: 0, // 记录元素初始位置
      // 公告栏：来自 GET /api/Home/SystemInfo 的 data.notices
      notices: [],
    };
  },
  components: {
    "p-custom-button": CustomButton,
    "p-custom-block-title": CustomBlockTitle,
    "p-live-drop-box": LiveDropBox,
    "c-button": Button,
    "c-picture": Picture,
    "c-block-panel": BlockPanel,
    "c-award": Award,
    "c-notice-board": NoticeBoard,
    "c-number": Number,
    "c-caseimg": CaseImg,
    "c-interactive-panel": InteractivePanel,
    "c-new-multiple-people-case": NewMultiplePeopleCase,
    "c-countDown": countDownModel,
    "c-case-item": caseItem,
    "c-gameInstanceBox": gameInstanceBox,
    "c-room-con-item": roomConItem,
    RollBox
  },
  filters: {
    conversion,
    addZero,
    countDown,
    format_date,
    format_case_name,
    GetItemDuration,
    GetItemName,
    GetItemSkinName,
    timeToCounter,
  },
  computed: {
    ...RollRoomsMapGetters(["home_roll_rooms"]),
    ...mapState([
      "config",
      "loginModal",
      "banner_list",
      "user",
      "notice_list",
      "GobalInfo",
      "currentCate",
    ]),
    curUserRealId() {
      return parseInt(this.user.id );
    },
    noticeText() {
      if (!this.notice_list || !this.notice_list.length) return '"0群CDK"需要添加网站右侧的QQ群，去群中咨询管理..';
      const n = this.notice_list[0];
      return (n && (n.content || n.title || n.text || n.notice)) || '"0群CDK"需要添加网站右侧的QQ群，去群中咨询管理..';
    },
    // 公告列表（用于上下滚动）：优先使用 Vuex store 中的 notice_list（父组件 home.vue 已获取），
    // 其次使用本地 this.notices，复制一份实现无缝循环
    noticeList() {
      const src = (this.notice_list && this.notice_list.length) ? this.notice_list : this.notices;
      const list = (src || []).filter((n) => n.status === 1);
      if (list.length === 0) return [];
      return [...list, ...list];
    },
    dailyRoiiCount() {
      return this.roiiList.length || 6;
    },
    dailyRoiiProgress() {
      return Math.min(100, (this.roiiList.length / 10) * 100) || 6;
    },
    roiiHeroBg() {
      return require('@/assets/images/roll/csgo.png');
    },
    designCards() {
      return [
        { id: 'battle', featureKey: 'battle', name: '盲盒对战', route: { name: 'battle' }, bgImage: require('@/assets/images/home_new/mhdz.png'), bgStyle: { background: 'linear-gradient(135deg, rgba(245,184,68,0.15) 0%, rgba(143,107,40,0.1) 100%)' } },
        [
          [
            { id: 'mp', featureKey: 'multiple_people_case', name: '多人开箱', route: { name: 'multiplePeopleCaseList', params: { tabType: 'all' } }, bgImage: require('@/assets/images/home_new/drkx1.png'), bgStyle: { background: 'linear-gradient(135deg, rgba(100,180,100,0.2) 0%, rgba(40,100,40,0.1) 100%)' } },
            { id: 'hld', featureKey: 'jollybeans', name: '欢乐豆免费游戏', route: { name: 'jollybeans' }, bgImage: require('@/assets/images/home_new/hld_balance.png'), bgStyle: { background: 'linear-gradient(135deg, rgba(245,184,68,0.2) 0%, rgba(180,140,40,0.1) 100%)' } },
          ],
          [
          { id: 'upgrade', featureKey: 'upgrade', name: '饰品升级', route: { name: 'upgradeList' }, bgImage: require('@/assets/images/home_new/upgrade.png'), bgStyle: { background: 'linear-gradient(135deg, rgba(180,100,245,0.2) 0%, rgba(100,60,180,0.1) 100%)' } },
          { id: 'box', featureKey: 'box', name: '盲盒开箱', route: { name: 'boxClassics' }, bgImage: require('@/assets/images/home_new/case.png'), bgStyle: { background: 'linear-gradient(135deg, rgba(100,150,245,0.2) 0%, rgba(60,100,180,0.1) 100%)' } },
          { id: 'crash', featureKey: 'crash', name: 'crash', route: { name: 'crash' }, bgImage: require('@/assets/images/home_new/crash.png'), bgStyle: { background: 'linear-gradient(135deg, rgba(245,200,100,0.2) 0%, rgba(200,150,50,0.1) 100%)' } },
          { id: 'anticheat', featureKey: 'case_history', name: '防作弊Hash', route: { name: 'caseHistory' }, bgImage: require('@/assets/images/home_new/hash_verify.png'), bgStyle: { background: 'linear-gradient(135deg, rgba(80,120,160,0.2) 0%, rgba(40,80,120,0.1) 100%)' } },
          ]
        ],
        { id: 'chicken_road', featureKey: 'chicken_road', name: 'Chicken Road', route: { name: 'chicken-road' }, bgImage: require('@/assets/images/home_new/cr.png'), bgStyle: { background: 'linear-gradient(135deg, rgba(220,80,80,0.2) 0%, rgba(180,40,40,0.1) 100%)' } },
      ];
    },
    cateCaseList() {
      let price_range_item = {};
      this.price_range_list.forEach((item) => {
        if (item.value == this.price_range_value) {
          price_range_item = item;
          return;
        }
      });
      return (cate) => {
        if (!this.boxList || !this.boxList.list) {
          return [];
        }
        let newArr = [];
        return this.boxList.list.filter(
          (_) =>
            (_.catagory == cate ||
              (cate == "all" && _.catagory != "副本箱列表")) &&
            _.price >= price_range_item.min &&
            _.price <= price_range_item.max &&
            (_.riskLevel == this.risk_sort_index ||
              this.risk_sort_index == "all")
        );
      };
    },
  },
  watch: {
    "loginModal.isLoginSuccess": {
      async handler(val) {
        console.log("val==", val);
        if (val == "success") {
          this.isRequest = false;
          await this.onInitData();
          this.loginModal.isLoginSuccess = null;
        }
      },
      deep: true,
      immediate: true,
    },
    price_sort_index: {
      handler(val) {
        if (val == "descending") {
          this.boxList.list.sort((a, b) => b.price - a.price);
        } else if (val == "ascending") {
          this.boxList.list.sort((a, b) => a.price - b.price);
        }
      },
      deep: true,
    },
  },
  async mounted() {
    await this.onInitData();

    const meta = this.$route.meta
    if (meta && meta.pendingScroll) {
      window.scrollTo({
        top: meta.pendingScroll.y,  // 使用保存的滚动位置 
      })
    }

    // 监听滚动事件（设计稿首页无 sticky 栏，仅当存在时监听）
    if (this.$refs.stickyElement) {
      this.stickyOffset = this.$refs.stickyElement.offsetTop;
      window.addEventListener("scroll", this.handleScroll);
    }
  },
  beforeDestroy() {
    if (this.mpcCaseTimer) {
      clearInterval(this.mpcCaseTimer);
    }
    // 移除滚动事件监听
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    ...RollRoomsMapActions(["refresh_home_roll_rooms"]),
    async onInitData() {
      // 如果 Vuex store 中还没有公告数据，才自行请求（避免与父组件重复请求同一 URL 被 axios 取消）
      if (!this.notice_list || !this.notice_list.length) {
        await this.getSystemInfo();
      }
      await this.getRoiiList();
      await this.getboxList();
      await this.getGameInstanceBoxList();
      await this.getRollRoomList();
      await this.initBattleHub();

    },
    async getRoiiList() {
      this.roiiListLoading = true;
      try {
        const res = await roll_list({ type: 0, size: 6, page: 1 });
        const ok = res?.data?.success === true || res?.data?.code === 0;
        const list = res?.data?.data;
        if (!ok || !Array.isArray(list)) {
          this.roiiList = [];
          return;
        }
        const flat = [];
        list.forEach((room) => {
          (room.items || []).forEach((it) => {
            flat.push({
              id: room.id,
              createTime: it.createTime || '--',
              quantity: 1,
              item: {
                itemPic: it.itemPic,
                name: it.name,
                rarity: it.rarity,
                sellPrice: it.price,
              },
              timeText: (it.name && GetItemDuration(it.name)) || (it.createTime ? format_date(it.createTime, 'HH:mm') : '--') || '--',
            });
          });
        });
        this.roiiList = flat;
      } catch (e) {
        this.roiiList = [];
      } finally {
        this.roiiListLoading = false;
      }
    },
    async getSystemInfo() {
      try {
        const res = await apis.GetSystemInfo();
        const ok = res?.data?.success === true || res?.data?.code === 0;
        const data = res?.data?.data;
        if (ok && data && Array.isArray(data.notices)) {
          this.notices = data.notices;
        } else {
          this.notices = [];
        }
      } catch (e) {
        this.notices = [];
      }
    },
    async getIndexHistory() {
      try {
        const res = await apis.indexHistory({});
        if (res.data.code === 0 && res.data.data && res.data.data.list) {
          const list = (res.data.data.list || []).slice(0, 10);
          this.roiiList = list.map((it) => ({
            ...it,
            dateText: it.createTime ? format_date(it.createTime, "M月D日") : "--",
            timeText: (it.item && it.item.name && GetItemDuration(it.item.name)) || "--",
            quantity: it.quantity != null ? it.quantity : 1,
          }));
        }
      } catch (e) {
        this.roiiList = [];
      }
    },
    async getboxList() {
      let _this = this;
      const boxList_response = await apis.boxList();
      if (boxList_response.data.code !== 0) {
        return;
      }
      _this.boxList = boxList_response.data.data;
      console.log("_this.boxList==", _this.boxList);
    },
    async getGameInstanceBoxList() {
      let _this = this;
      _this.cateCaseList("副本箱列表").forEach(async (boxItem, boxIndex) => {
        // 如果存在对应副本箱，副本加个字段，首页显示
        boxItem["isAccumulateExtraCasesShow"] = false;
        _this.boxList.list.forEach(async (items) => {
          //是否有累计副本箱=母箱
          if (
            items.isEnableAccumulateCase &&
            items.accumulateExtraCaseId &&
            items.accumulateExtraCaseId == boxItem.caseId
          ) {
            items.awardAccumulateExtraCases =
              items.awardAccumulateExtraCases.filter((res) => {
                return res.extraCaseId == items.accumulateExtraCaseId;
              });
            //如果存在对应副本箱，副本加个字段，首页显示
            if (items.awardAccumulateExtraCases.length > 0) {
              boxItem.isAccumulateExtraCasesShow = true;
            }
          }
        });
      });
    },

    //获取连胜挑战信息GCRequestChallengeInfo接口
    initBattleHub() {
      if (this.$caseBattleHub.conn.state == "Connected") {
        //连接存在
        this.CGReqBattleChallengeDetails();
      }
      this.$caseBattleHub.onConnected = () => {
        this.CGReqBattleChallengeDetails();
      };
      this.$caseBattleHub.onReconnected = () => {
        this.CGReqBattleChallengeDetails();
      };
    },
    CGReqBattleChallengeDetails() {
      this.$caseBattleHub.conn
        .invoke("GCRequestChallengeInfo")
        .then((cpMsg) => {
          console.log("获取连胜挑战信息==GCRequestChallengeInfo", cpMsg);
          this.battleChallengeDetail.isChallengeEnable =
            cpMsg.data.isChallengeEnable;
        });
    },

    onClickCaseItmHandle(type) {
      this.active_cate = type;
      this.$forceUpdate();
    },
    getRollRoomList() {
      roll_list({ type: 0, size: 3, page: 1 }).then((res) => {
        if (res.data.code === 0) {
          this.roll_room_list = [];
          res.data.data.forEach((item, index) => {
            if (item && item.items && item.items.length) {
              this.roll_room_list.push(item);
            }
          });
        }
      });
    },
    pathGo(obj, featureKey) {
      if (featureKey && !this.$canShowFeature(featureKey)) {
        return;
      }
      // 如果 route 为 null，表示该卡片不可点击，直接返回
      if (!obj || obj === null) {
        return;
      }
      if (obj.name === "case") {
        return this.$router.push({
          name: "case",
          params: { id: obj.id },
          query: this.$route.query || {},
        });
      }
      this.$router.push({ ...obj, query: { ...(this.$route.query || {}), ...(obj.query || {}) } });
    },
    openCreateRoomModal() {
      if (!this.user.nickname) return this.$store.commit("setloginModal", true);

      this.new_multiplePeople_cases_show = true;
    },
    /** swiper 自动播放切换 */
    async on_swiper_autoplay_toggle(swiper, event) {
      if (!swiper) return null;

      event.type === "mouseleave" && swiper.autoplay.start();

      event.type === "mouseenter" && swiper.autoplay.stop();
    },

    /** 更新箱子价格按钮状态 */
    async update_case_price_is_active({
      cases_category_index,
      case_item_index,
      is_active,
    }) {
      let case_price_ref =
        this.$refs[`case_price_${cases_category_index}_${case_item_index}`];
      case_price_ref = case_price_ref
        ? case_price_ref[0]
          ? case_price_ref[0]
          : null
        : null;

      if (case_price_ref === null) return;

      case_price_ref.update_button_is_active(is_active);
    },
    onShaixuanHandle() {
      this.isShowShaixuan = !this.isShowShaixuan;
    },
    onScrollLeft() {
      // 获取要滚动的元素
      let element = this.$refs.categoryItems;
      console.log("element==", element);
      // 滚动到水平位置100px
      element.scrollTo({
        left: 0, // 目标位置，相对于该元素的左边框
        behavior: "smooth", // 可选，平滑滚动效果
      });
    },
    onScrollRight() {
      // 获取要滚动的元素
      let element = this.$refs.categoryItems;
      console.log("element==", element);
      console.log("scrollWidth==1", element.scrollWidth);
      element.scroll({
        left: 500, // 向右滚动500像素
        top: 0, // 不改变垂直位置
        behavior: "smooth", // 平滑滚动效果
      });
      // element.scrollBy(500, 0); // 在当前位置向右滚动500像素
    },

    handleScroll: _.debounce(function() {
      const scrollY = window.scrollY || window.pageYOffset;
      this.isFixed = scrollY >= this.stickyOffset;
    }, 50),
  },
};
